// extracted by mini-css-extract-plugin
export var body = "AuthorCover-module--body--b2527";
export var container = "AuthorCover-module--container--4d397";
export var heading = "AuthorCover-module--heading--96151";
export var inner = "AuthorCover-module--inner--474fd";
export var photo = "AuthorCover-module--photo--7210d";
export var qualifications = "AuthorCover-module--qualifications--ee09f";
export var specialities = "AuthorCover-module--specialities--f507c";